import React from "react";
import { Row, Col, Statistic } from "antd";
import moment from "moment";
import { FigureInfomationWrapper } from "./styles";
import { useTranslation } from 'react-i18next'
import { grades } from "../../constants";

const RenderFigureData = ({ selectedArticle,src }) => {
  
  const { t } = useTranslation();
  const gradeText = selectedArticle && grades.find(grade => grade.value === selectedArticle.grade).name;
  const limiteElastico = selectedArticle && selectedArticle.EspMecanicas.limiteElastico;
  const ResAtraccion = selectedArticle && selectedArticle.EspMecanicas.resistenciaAtraccion;
  const EneImpacto = selectedArticle && selectedArticle.EspMecanicas.EnergiaImp.Valor+"J - "+selectedArticle.EspMecanicas.EnergiaImp.temp+"ºC";
  
  if (!selectedArticle) return null;
  return (
    <FigureInfomationWrapper>
        <Row style={{ margin: 0 }} gutter={[16, 16]}>

            <Col span={24}>
                <img 
                    alt="Pieza"
                    style={{ width: 117, height: 73, marginleft:'40%' }}
                    src={src}
                />
            </Col>

            <Col span={12} key="figure" style={{ marginTop: 20 }}>
            <Statistic title={t('table.header.geometryFin')}value={selectedArticle && selectedArticle.geometriaFinal } suffix="" />
            </Col>
            <Col span={12} key="date" style={{ marginTop: 20 }}>
            <Statistic
                title={t('labels.article_date')}
                value={selectedArticle && selectedArticle.date && moment(selectedArticle.date).format("DD/MM/YYYY HH:mm:ss")}
                suffix=""
            />
            </Col>
            <Col span={12} key="grado_acero" style={{ marginTop: 25 }}>
            <Statistic title={t('labels.steel_grade')} value={gradeText} suffix="" precision={0} />
            </Col>

            <Col span={12} key="limiteElastico" style={{ marginTop: 25 }}>
            <Statistic title={t('labels.LimiteElastico')} value={limiteElastico} suffix="MPa" precision={0} />
            </Col>
            <Col span={12} key="ResAtraccion" style={{ marginTop: 25 }}>
            <Statistic title={t('labels.ResAtraccion')} value={ResAtraccion} suffix="MPa" precision={0} />
            </Col>
            <Col span={12} key="limiteElastico" style={{ marginTop: 25 }}>
            <Statistic title={t('labels.EneImpacto')} value={EneImpacto} suffix="" precision={0} />
            </Col>

        </Row>
    </FigureInfomationWrapper>
  );
};

export default RenderFigureData;
